<template>
<div>
  <PageTitle :route="$route">
    <template slot="action-button">
      <ActionButton
        icon="fa-plus"
        v-on:click="onClickButton"
      />
    </template>
  </PageTitle>

  <PageRowWrapper>
    <div class="col-sm-12">
      <ArenaEventList />
    </div>
  </PageRowWrapper>
</div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ActionButton from '@/components/button/ActionButton'
import ArenaEventList from '@/components/settings/app-frotix-registers/arenaevent/ArenaEventList'

export default {
  name: 'ArenaEventListView',
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    ArenaEventList
  },
  methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addarenaevent' })
    }
  }
}
</script>
